import KatalLogger from "@amzn/katal-logger"
import DummyLogger from "./DummyLogger"
import { logErrorMessage } from "./emfLogs"
import { SERVICE_NAME, Stages, LogThresholds } from "./loggerConstants"

let logger;

if (!enableLogger()) {
    logger = new DummyLogger;
} else {
    logger = new KatalLogger({
        url: process.env.REACT_APP_CLIENT_LOGGER_URL,
        logThreshold: process.env.REACT_APP_STAGE === Stages.Prod ? LogThresholds.Info : LogThresholds.Debug,
        maxLogsPerBatch: 25,
        maxLogLineSize: 10000,
        decodeStackTrace: false, // Note: enabling could increase CloudWatch Logs storage costs
        logToConsole: process.env.REACT_APP_STAGE !== Stages.Prod,
        recordMetrics: false,
        context: {
            serviceName: SERVICE_NAME,
            serviceStage: process.env.REACT_APP_STAGE
        }
    });
}

logger.addErrorListener((error) => {
    logErrorMessage(error);
    return true;
})

function enableLogger() {
  return process.env.REACT_APP_STAGE === Stages.Alpha
    || process.env.REACT_APP_STAGE === Stages.Beta
    || process.env.REACT_APP_STAGE === Stages.Prod;
}

export default logger;
